/*
 * @description:
 * @author: Jason Wong
 * @since: 2019-03-21 10:57:29
 */

import Vue from "vue";
import SimpleLoading from "@/components/LoadingOia";
import progressLoading from "@/components/loadingProgress";
import Router from "../../router";
import ENV, { mode } from "../../configs/env";

let CUSTOM_LOADING_ZINDEX = 1200;
let CUSTOM_LOADING_BACKGROUND = "rgba(0, 0, 0, 0.3)";

/**
 *
 * @param {*} options
 * @returns
 */
function createLoadingComponentWrapper(options) {
  const opt = options || {};
  let root = document.createElement("div");
  root.setAttribute("class", "el-loading-mask");
  const zIndex = opt.zIndex || CUSTOM_LOADING_ZINDEX++;
  root.style.zIndex = "" + zIndex;
  root.style.background = opt.background || CUSTOM_LOADING_BACKGROUND;

  let contentWrapper = document.createElement("div");
  contentWrapper.className = "el-loading-spinner custom";
  root.appendChild(contentWrapper);
  return { root, contentWrapper };
}
/**
 *
 * @param {Object} component
 * @param {{
 *  target:String|Element,
 *  zIndex:Number,
 *  data:Object
 * }} options
 */
function createLoadingComponent(component, options) {
  const ComponentCls = Vue.extend(component);
  let componentOptions = {};
  !!options.props && (componentOptions.propsData = options.props);
  !!options.data && (componentOptions.data = options.data);
  const componentsInstance = new ComponentCls(componentOptions);
  componentsInstance.$mount();
  let el = componentsInstance.$el;
  let target = document.body;
  if (options) {
    if (options.target) {
      if (typeof options.target == "string") {
        let tempEl = document.querySelector(options.target);
        tempEl && (target = tempEl);
      } else {
        target = options.target;
      }
    }
  }

  el.classList.add("transform-x-center");
  let loadingWrapper = createLoadingComponentWrapper(options);
  loadingWrapper.contentWrapper.appendChild(el);
  loadingWrapper.root.classList.add("close-to-transparent__imp");
  target.appendChild(loadingWrapper.root);
  if (target == document.body) {
    loadingWrapper.root.style.position = "fixed";
  }
  el.$$wrapper = loadingWrapper.root;
  return componentsInstance;
}

let LOADERS_OF_CURRENT_ROUTER = [];

/**
 *
 * @param {{close:()=>void}} loader
 */
function removeLoader(loader) {
  const pos = LOADERS_OF_CURRENT_ROUTER.indexOf(loader);
  if (pos > -1) {
    LOADERS_OF_CURRENT_ROUTER.splice(pos, 1);
  }
}

/**
 *
 * @returns
 */
function clearAllLoaders() {
  if (LOADERS_OF_CURRENT_ROUTER.length < 1) return;
  LOADERS_OF_CURRENT_ROUTER.$$each((loader) => {
    try {
      loader.close();
    } catch (err) {
      if (ENV.mode == mode.development) {
        console.error(`Failed to close loader,message:${err}`);
      }
    }
  });
  LOADERS_OF_CURRENT_ROUTER.splice(0, LOADERS_OF_CURRENT_ROUTER.length);
}

Router.afterEach((to, from) => {
  clearAllLoaders();
});

const LOADER_COMPONENT_MAP = {
  default: SimpleLoading,
  progress: progressLoading,
};
function LoaderComponentFactory(name) {
  name = name || "default";
  if (!name) return SimpleLoading;
  const component = LOADER_COMPONENT_MAP[name];
  if (!component) {
    throw new Error(`Loader component named ${name} dosen't esit.`);
  }
  return component;
}

export default {
  install(vue, options) {
    vue.prototype.$$confirmEx = function (...args) {
      return new Promise((rs, rj) => {
        this.$confirm(...args)
          .then(() => {
            rs(true);
          })
          .catch((err) => {
            rs(false);
          });
      });
    };

    vue.prototype.$$loading_old = function (msg, options) {
      const target = options && options.target ? options.target : "#innerContent";
      const loader = this.$loading({
        target: target,
        lock: false,
        text: msg || "正在查询，请稍候...",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.1)",
        fullscreen: false,
        body: (options || {}).body || false,
      });
      LOADERS_OF_CURRENT_ROUTER.push(loader);
      return loader;
    };

    /**
     * 展示一个加载框
     * @param {String} msg
     * @param {{
     *  component?:Object|String,
     *  target?:String|Element,
     *  zIndex?:Number,
     *  data?:Object
     * }} options
     * @returns
     */
    vue.prototype.$$loading = function (msg, options) {
      options = { lazy: true, ...(options || {}) };
      let componentTemplate =
        !options.component || typeof options.component == "string"
          ? LoaderComponentFactory(options.component)
          : options.component;
      let component = null;
      let isLoading = true;
      component = createLoadingComponent(componentTemplate, options);

      if (options.lazy) {
        setTimeout(() => {
          if (isLoading) {
            component.$el.$$wrapper.classList.remove("close-to-transparent__imp");
          }
        }, options.lazyDuration || 500);
      }
      const loader = {
        updateData(keyValues) {
          if (!component) {
            options.data = options.data || {};
            for (let key of Object.keys(keyValues)) {
              options.data[key] = keyValues[key];
            }
          } else {
            for (let key in keyValues) {
              component.$data[key] = keyValues[key];
            }
          }
        },
        close() {
          isLoading = false;
          if (!component) return;

          removeLoader(loader);
          component.$el.$$wrapper.remove();
          if (component.$el.$$wrapper.style && component.$el.$$wrapper.style.zIndex) {
            const elZIndex = parseInt(component.$el.$$wrapper.style.zIndex);
            //return zIndex for economize
            if (elZIndex == CUSTOM_LOADING_ZINDEX - 1) {
              CUSTOM_LOADING_ZINDEX--;
            }
          }
          component.$destroy();
        },
      };
      LOADERS_OF_CURRENT_ROUTER.push(loader);
      return loader;
    };

    vue.prototype.$$info = function (msg, title) {
      return this.$alert(msg, title, {
        showClose: false,
        confirmButtonText: "确定",
        type: "warning",
        lockScroll: false,
      });
    };

    vue.prototype.$$warn = function (msg, title) {
      return this.$alert(msg, title || "系统提示", {
        showClose: false,
        confirmButtonText: "确定",
        type: "warning",
        lockScroll: false,
      });
    };

    vue.prototype.$$error = function (msg, title, attrs) {
      return this.$alert(msg instanceof Error ? msg.message : msg, title || "系统提示", {
        showClose: false,
        confirmButtonText: "确定",
        type: "error",
        lockScroll: false,
        dangerouslyUseHTMLString: true,
        ...(attrs || {}),
      });
    };

    vue.prototype.$$success = function (msg, title) {
      return this.$alert(msg, title, {
        showClose: false,
        confirmButtonText: "确定",
        type: "success",
        lockScroll: false,
      });
    };

    vue.prototype.$$flash = function (msgObj, type = "info") {
      msgObj = msgObj || {};
      let msgText = !!msgObj.message ? msgObj.message : msgObj;
      console.log("#_# msgText", msgText);
      return this.$message({
        message:msgText,
        type,
      });
    };

    vue.prototype.$$confirm = function (msg, title) {
      return this.$confirm(msg, title || "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        lockScroll: false,
        cancelButtonClass: "is-plain",
      });
    };

    vue.prototype.$$confirmEx = async function (msg, title) {
      try {
        await this.$confirm(msg, title || "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          lockScroll: false,
          cancelButtonClass: "is-plain",
        });
        return true;
      } catch (err) {
        if (err && `${err}`.toUpperCase() == "CANCEL") {
          return false;
        }
        throw err;
      }
    };

    vue.prototype.$$alert = function (msg, title) {
      return this.$alert(msg, title || "系统提示", {
        dangerouslyUseHTMLString: true,
        showConfirmButton: false,
        showCancelButton: true,
        cancelButtonText: "关闭",
        cancelButtonClass: "is-plain",
        customClass: "alert-box-width",
      });
    };
  },
};
